import { Box, Button, SvgIcon, Typography } from '@mui/material';
import FileDownload from 'mdi-react/FileDownloadIcon';
import KeyboardArrowRightIcon from 'mdi-react/KeyboardArrowRightIcon';
import { func, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const Headline = ({ onOpen, name, onExport, ...props }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: '20px',
    }}
  >
    <Typography {...props} sx={{ display: 'flex', alignItems: 'center' }} variant="h5">
      <Box component="span" sx={{ fontWeight: 'normal', color: 'secondary.main' }}>
        {I18n.t('AnalyticsDrawer.Docs')}
      </Box>{' '}
      <Box
        component="span"
        sx={{ color: 'secondary.main', display: 'inline-flex', verticalAlign: 'middle' }}
      >
        <KeyboardArrowRightIcon />
      </Box>{' '}
      {name}
    </Typography>
    <Box sx={{ display: 'flex' }}>
      <Button
        variant="outlined"
        color="secondary"
        sx={{ color: 'primary.ultraDark', mr: '10px' }}
        onClick={onExport}
      >
        <SvgIcon sx={{ fontSize: 18, mr: '5px', color: 'primary.main' }}>
          <FileDownload />
        </SvgIcon>
        {I18n.t('AnalyticsDrawer.Export responses')}
      </Button>
      <Button color="secondary" variant="outlined" onClick={onOpen}>
        {' '}
        {I18n.t('AnalyticsDrawer.Open file')}
      </Button>
    </Box>
  </Box>
);

Headline.propTypes = {
  name: string.isRequired,
  onOpen: func.isRequired,
  onExport: func.isRequired,
};

export default Headline;
